import React, { useMemo, useState } from 'react'
import classes from '../../pages/Account/Subscription/subscription.module.css'
import Checkbox from '../Form/Checkbox/Checkbox'
import classNames from 'classnames'
import { Button } from '../Button/Button'
import Modal from '../Modal/Modal'
import {
    cancelUserSubscription,
    hasFreeCourses,
} from '../../pages/Account/CancelSubscription/cancelSubscriptionApi'
import notification from '../Notification/notification'
import {
    getCurrentSub,
    getSubHistory,
} from '../../pages/Account/Subscription/subscriptionApi'
import { getErrorMessage } from '../../util/functions'
import { useDispatch, useSelector } from 'react-redux'
import { userSelectors } from '../../redux/userSlice'
import { useHistory } from 'react-router'

const cancelReasons = [
    'I want to upgrade to a new one',
    'My current package limits my access',
    'I did not get the free courses allocated to the plan',
    'I found a better service elsewhere',
    `I couldn't find relevant courses and information`,
]

const CancelModal = ({ modalOpen, onClose }) => {
    const moddedReasons = useMemo(
        () =>
            cancelReasons.map(reason => ({
                reason,
                checked: false,
            })),
        []
    )

    const [reasons, setReasons] = useState(moddedReasons)

    const toggleReasonActive = index => {
        const moddedReasons = [...reasons]
        moddedReasons[index].checked = !moddedReasons[index].checked
        setReasons(moddedReasons)
    }
    console.log('gad', reasons)
    const user = useSelector(userSelectors.userDetails)

    const dispatch = useDispatch()
    const history = useHistory()

    const onCancel = () => {
        //TODO: Save cancel reasons somewhere
        const concatenatedReasons = reasons?.reduce((acc, item) => {
            if (item.checked) {
                const prefix = acc.length === 0 ? '' : ';'
                acc += prefix + item.reason
            }
            return acc
        }, '')

        // hasFreeCourses(user.email)
        //     .then(hasFree => {
        //         if (hasFree) {
        //             history.push('/app/account/cancel-subscription')
        //             return false
        //         } else {
        //             notification.loading({
        //                 title: 'Cancelling subscription',
        //             })
        //             return cancelUserSubscription(
        //                 user.email,
        //                 concatenatedReasons
        //             )
        //         }
        //     })
        notification.loading({
            title: 'Cancelling subscription',
        })

        cancelUserSubscription(user.email, concatenatedReasons)
            .then(cancelling => {
                if (cancelling) {
                    notification.destroy()
                    notification.success({
                        title: 'Subscription cancelled succesfully',
                    })
                    dispatch(getCurrentSub(user.email))
                    dispatch(getSubHistory(user.email))
                }
            })
            .catch(e => {
                notification.destroy()
                notification.failure({
                    title: 'Something went wrong',
                    description: getErrorMessage(e),
                })
            })
            .finally(onClose)
    }

    return (
        <Modal
            open={modalOpen}
            onRequestDismiss={onClose}
            className={classes.cancelModal}
        >
            <h3 className={classes.cancelModalHeader}>
                Continue with Subscription cancellation
            </h3>
            <span className={classes.cancelModalSplitLine} />
            <h5 className={classes.cancelModalSubText}>
                We are sorry to see you go. Would you mind telling us why you
                want to cancel your subscription?
            </h5>
            <div className={classes.cancelModalReasons}>
                {reasons.map(({ reason, checked }, index) => (
                    <div className={classes.cancelModalReason}>
                        <Checkbox
                            checked={checked}
                            onToggle={toggleReasonActive}
                            id={index}
                        />
                        <span>{reason}</span>
                    </div>
                ))}
            </div>
            <span className={classes.cancelModalSplitLine} />
            <div className={classes.cancelModalButtons}>
                <button
                    className={classNames(
                        classes.cancelModalCloseButton,
                        classes.cancelModalButton
                    )}
                    onClick={onClose}
                >
                    Close
                </button>
                <Button
                    className={classes.cancelModalButton}
                    onClick={onCancel}
                >
                    Confirm
                </Button>
            </div>
        </Modal>
    )
}

export default CancelModal
